<mat-card>
  <mat-card-header class="d-flex justify-content-between">
    <mat-card-title> Service Provider </mat-card-title>

    <div class="d-flex align-items-center">
      <div>{{ utils.getStatus(serviceProvider.status) }}</div>
      <mat-icon class="ms-2 {{ utils.getStatusColor(serviceProvider.status) }}">
        {{ utils.getStatusIcon(serviceProvider.status) }}
      </mat-icon>
    </div>
  </mat-card-header>

  <mat-card-content>
    @if ($fetchedAt | async) {

    <div class="img-holder">
      <input
        #fileInput
        type="file"
        (change)="onFileChange($event)"
        accept=".png, .jpg, .jpeg"
      />

      <img [src]="serviceProvider.imageUrl" alt="Service Provider Logo" class="img-fluid" />

      <button mat-icon-button class="icon" (click)="fileInput.click()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>

    <div class="container">
      <form [formGroup]="form" class="mt-4">
        <mat-form-field class="w-100">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" type="text" />
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>API Key</mat-label>
          <input disabled="disabled" matInput [value]="serviceProvider.apiKey" />
        </mat-form-field>

        @if (error) {
        <app-alert class="mt-3" type="error" (close)="error=null">
          {{ error }}
        </app-alert>
        }

        <div class="d-flex align-items-center justify-content-end mt-3">
          @if (loading) {
          <mat-progress-spinner
            class="me-2"
            mode="indeterminate"
            color="primary"
            diameter="30"
          />
          }

          <div style="display: flex">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              class="px-4"
              [disabled]="loading"
              (click)="onFormSubmit()"
            >
              Update Service Provider
            </button>
          </div>
        </div>
      </form>

      <div class="d-flex align-items-center justify-content-end mt-4">
        <button
          (click)="onToggleServiceProviderStatusClicked()"
          [disabled]="loading"
          mat-raised-button
          [color]="serviceProvider.status == 'approved' ? 'warn' : 'primary'"
          class="px-4"
        >
          {{ serviceProvider.status == 'approved' ? 'Disable Service Provider' : 'Enable Service Provider'
          }}
        </button>
      </div>
    </div>
    }
    <!---->
    @if (!($fetchedAt | async)) {
    <div class="d-flex justify-content-center">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    }
  </mat-card-content>
</mat-card>

@if (($fetchedAt | async)) {
<div class="mt-4">
  <app-service-provider-admins [serviceProvider]="serviceProvider" />
</div>
}


